import { Component, Input, OnInit } from "@angular/core";
import { GlobalsService } from "src/app/api/globals.service";
import { NavController, AlertController, LoadingController } from "@ionic/angular";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActividadesService } from "src/app/services/actividades.service";
import { AuthService } from "src/app/services/auth.service";
import { ComponentDataService } from "src/app/services/component-data.service";
import { SearchService } from "src/app/services/search.service";
import { PerfilService } from "src/app/services/perfil.service";
import { data } from "jquery";

@Component({
  selector: "app-crear-pupilo-tutor",
  templateUrl: "./crear-pupilo-tutor.component.html",
  styleUrls: ["./crear-pupilo-tutor.component.scss"],
})
export class CrearPupiloTutorComponent implements OnInit {
  private id: number;

  public id_user = 0;
  displayUserData: any;
  searchPersonsResult = [];
  avatar = "assets/imagenes/sistema/user1.png";
  private auth_key: string = "";

  pupiloTutor: FormGroup;
  listPupilo = [];
  listTutor = [];
  public loaderToShow;

  constructor(
    public globalsService: GlobalsService,
    public formBuilder: FormBuilder,
    public alertController: AlertController,
    private authService: AuthService,
    public actividadesService: ActividadesService,
    public dataService: ComponentDataService,
    private searchService: SearchService,
    public navCtrl: NavController,
    public perfilService: PerfilService,
    public loadingCtrl: LoadingController
  ) {
    this.createFormPupiloTutor();
    this.id = this.displayUserData?.id;
    let auth_key = "";
    this.authService.userData$.subscribe((res: any) => {
      this.displayUserData = res;
      auth_key = this.displayUserData?.auth_key;
      this.id_user = this.displayUserData?.id;
      if (auth_key) {
        this.auth_key = auth_key;
        this.LoadTutorPupilo();
        this.searchPersons();
      }
    });
  }
  ngOnInit() {}

  createFormPupiloTutor() {
    this.pupiloTutor = this.formBuilder.group({
      pupiloTutor: ["", Validators.required],
    });
  }

  LoadTutorPupilo() {
    this.perfilService
      .getPupilosTutores(this.id_user, this.auth_key)
      .subscribe((res: any) => {
        this.listPupilo = res.pupilos;
        this.listTutor = res.tutores;
        console.log("🚀 ~ CrearPupiloTutorComponent ~ LoadTutorPupilo ~ this.id_user:", this.id_user)
        console.log("🚀 ~ this.perfilService.getPupilosTutores ~ res:", res);
      });
  }
     

  searchPersons() {
    this.searchService
      .getAllResult(this.id_user, this.auth_key)
      .subscribe((result) => {
        this.searchPersonsResult = result.Personas;
      });
  }

  savePupiloTutor(type: boolean) {
    const data = {
      id_pupilo: type
        ? this.pupiloTutor.get("pupiloTutor").value.id
        : this.id_user,
      id_tutor: !type
        ? this.pupiloTutor.get("pupiloTutor").value.id
        : this.id_user,
      id_aprueba: this.pupiloTutor.get("pupiloTutor").value.id,
    };
    this.showLoader();
    this.perfilService
      .createPupiloTutor(this.id_user, this.auth_key, data)
      .subscribe((res) => {
        this.actionSaveDescription(
          "¡Hecho!",
          "Se ha guardado correctamente el Pupilo y Tutor."
        );
        this.LoadTutorPupilo();
        this.hideLoader();
      });
  }
  async actionSaveDescription(header, message) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: header,
      message: message,
      buttons: [
        {
          text: "Aceptar",
          role: "cancel",
          cssClass: "secondary",
        },
      ],
    });

    await alert.present();
  }

  deletePupiloTutor(id_solicitud) {
    this.perfilService
      .deletePupiloTutor(this.id_user, this.auth_key, id_solicitud)
      .subscribe((res) => {
        this.actionSaveDescription(
          "¡Hecho!",
          "Se ha eliminado correctamente el Pupilo y Tutor."
        );
        this.LoadTutorPupilo();
      });
  }

  aprovePupiloTutor(id_solicitud) {
    this.perfilService
      .aprovePupiloTutor(this.id_user, this.auth_key, id_solicitud)
      .subscribe((res) => {
        this.actionSaveDescription(
          "¡Hecho!",
          "Se ha aprobado correctamente el Pupilo y Tutor."
        );
        this.LoadTutorPupilo();
      });
  }

  rejectedPupiloTutor(id_solicitud) {
    this.perfilService
      .rejectPupiloTutor(this.id_user, this.auth_key, id_solicitud)
      .subscribe((res) => {
        this.actionSaveDescription(
          "¡Hecho!",
          "Se ha rechazado correctamente el Pupilo y Tutor."
        );
        this.LoadTutorPupilo();
      });
  }

  showLoader() {
    this.loaderToShow = this.loadingCtrl
      .create({
        message: "Cargando...",
      })
      .then((res) => {
        res.present();
        res.onDidDismiss().then((dis) => {
          this.hideLoader();
        });
      });
  }

  hideLoader() {
    setTimeout(() => {
      this.loadingCtrl.dismiss();
    }, 200);
  }
}
